var exports = {};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = throwIfMissing;
/**
 * Throws a missing parameter error
 */

function throwIfMissing() {
  throw new Error("Missing parameter");
} //# sourceMappingURL=throwIfMissing.js.map


export default exports;